"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GravityGatewayAdapter = void 0;
const lodash_1 = require("lodash");
const ClientAdapter_1 = require("./ClientAdapter");
const ParserService_1 = require("./ParserService");
const Types_1 = require("./Types");
class GravityGatewayAdapter extends ClientAdapter_1.ClientAdapter {
    constructor(options) {
        super(options);
        this.setName();
        this.setMessageProtocol();
        this.setWebView();
    }
    subscribe() {
        if (this.handler) {
            // Unsubscribe before setting new listener to avoid duplicate messages
            this.handler.unsubscribe('*');
            this.handler.subscribe('*', (message) => {
                ParserService_1.parseAndDispatchEvent(message.action, message, this.useCommonEventName, this.name, this.options.proxyEvents, this.options.bounceToFrames);
            });
        }
    }
    getWebAppListener() {
        try {
            const webkitHandler = lodash_1.get(window, 'webkit');
            return webkitHandler && webkitHandler.messageHandlers && webkitHandler.messageHandlers.WebAppListener;
        }
        catch (error) {
            return undefined;
        }
    }
    setHandler(handler) {
        this.handler = handler;
        this.subscribe();
    }
    setName() {
        this.name = Types_1.ClientAdapters.GravityGatewayAdapter;
    }
    setMessageProtocol() {
        this.messageProtocol = 'gravityGateway';
    }
    setWebView() {
        const webViewHandler = (action, payload) => {
            const cleanMessage = JSON.stringify(payload);
            const message = JSON.parse(cleanMessage);
            ParserService_1.parseAndDispatchEvent(action, message, this.useCommonEventName, this.name, this.options.proxyEvents, this.options.bounceToFrames);
        };
        lodash_1.assign(window, {
            onParentMessage: webViewHandler,
        });
    }
    sendMessage(message, targetOrigin) {
        if (this.handler) {
            this.handler.emit(message, targetOrigin);
        }
        /*
        Support sending same gravity message using different
        protocols. For ios WebAppListener is used.
        */
        const webAppListener = this.getWebAppListener();
        if (webAppListener && lodash_1.isFunction(webAppListener.postMessage)) {
            webAppListener.postMessage(message);
        }
    }
}
exports.GravityGatewayAdapter = GravityGatewayAdapter;
//# sourceMappingURL=GravityGatewayAdapter.js.map